import { useEffect } from "react";

export default function Redirect({ to }) {
    useEffect(() => {
        window.location.href = "https://rubenholthuijsen.nl/" + to;
    }, [to]);
}